import { registerSW } from 'virtual:pwa-register'

/**
 * Web only. The installed PWA needs the service worker for offline use and Web
 * Push; the Capacitor app must not have one — see the note in vite.config.js.
 *
 * index.html sets is-native before any bundle runs, so this needs no plugin
 * import and stays out of the app's critical path.
 */
export function registerServiceWorkerOnWeb() {
    if (document.documentElement.classList.contains('is-native')) return
    registerSW({ immediate: true })
}
